import userApiClient from '../api/user';
import useAppContext from './useAppContext';
import useKlydoQuery from './useKlydoQuery';

// Safe default is "not b2b" (hidden): while the properties request is
// loading, or if it fails, `data` stays undefined and this returns false -
// b2b-only controls must never flash visible before we can confirm the flag.
const useIsB2BUser = (): boolean => {
  const { user } = useAppContext();

  const { data } = useKlydoQuery({
    queryKey: ['userProperties', user?.id],
    queryFn: () => userApiClient.getUserProperties(),
    enabled: !!user?.id,
  });

  return data?.b2b === true;
};

export default useIsB2BUser;
